import React, { ChangeEvent } from "react";
import { getMonthTypeInputValueFromDate } from "../../../utils";

interface AdvanceSalaryMonthAndYearFilterProps {
  selectedDate: Date | null;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export default function AdvanceSalaryMonthAndYearFilter({
  onChange,
  selectedDate,
}: AdvanceSalaryMonthAndYearFilterProps) {
  return (
    <div style={{ width: "40%" }}>
      <h6 style={{ color: "var(--clr-text-secondary)" }}>
        Month & Year Filter
      </h6>
      <input
        type="month"
        id="fromDate"
        className="form-control input-login"
        placeholder="From Date"
        value={getMonthTypeInputValueFromDate(selectedDate)}
        onChange={onChange}
        required
      />
    </div>
  );
}
